import i18n from '@/i18n'

export const columns = [
    {
        columnId: 1,
        name: i18n.t('OrderBill.OrderBill15'),
        key: "handle",
        width: "100",
    },
    {
        columnId: 2,
        name: i18n.t('fba.packBatchNo'),
        key: "containerBatchNo",
        width: 130,
    },
    {
        columnId: 3,
        name: i18n.t('OrderDetail.OrderDetail2'),
        key: "createTime",
        width: 160,
    },
    {
        columnId: 4,
        name: i18n.t('wzbg.wz5'),
        key: "status",
        minWidth: 130,
    },
    {
        columnId: 5,
        name: i18n.t('fba.fba1'),
        key: "invoice",
        minWidth: 150,
    },
    {
        columnId: 6,
        name: i18n.t('fba.fba2'),
        key: "sendTime",
        width: 160,
    },
    {
        columnId: 7,
        name: i18n.t('fba.fba3'),
        key: "boxNum",
        minWidth: 70,
    },
    {
        columnId: 10,
        name: i18n.t('BuddleOrder.BuddleOrder26'),
        key: "logisticsInfo",
        minWidth: 150,
    },
    {
        columnId: 14,
        name: i18n.t('select.select16'),
        key: "receiver",
        minWidth: 80,
    },
    {
        columnId: 15,
        name: i18n.t('fba.fba4'),
        key: "receiverCode",
        width: "100",
    },
    {
        columnId: 16,
        name: i18n.t('fba.fba5'),
        key: "senderAddress",
        width: "250",
    },
    {
        columnId: 16,
        name: i18n.t('BuddleOrder.BuddleOrder11'),
        key: "putIntent",
        width: "250",
    },
    {
        columnId: 17,
        name: i18n.t('fba.line'),
        key: "route",
        minWidth: "80",
    },
    {
        columnId: 18,
        name: i18n.t('goods.goods48'),
        key: "remark",
        width: "200",
    },
    {
        columnId: 19,
        name: i18n.t('mess.mess45'),
        key: "attachment",
        width: "200",
    }
];
